import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatRippleModule } from '@angular/material/core'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { TranslateModule } from '@ngx-translate/core'

import { ProgressButtonComponent } from './progress-button.component'

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatProgressBarModule,
    MatRippleModule,
    MatIconModule,
    TranslateModule,
  ],
  exports: [ProgressButtonComponent],
  declarations: [ProgressButtonComponent],
})
export class ProgressButtonModule {}
